module.exports = {
  aws: {
    key: 'aws',
    label: 'AWS',
  },
  twillio: {
    key: 'twillio',
    label: 'Twillio',
  },
};